<!-- Hero Section -->
<section class="terms-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">SAFROO</h1>
    <p class="hero-subtitle">Privacy Policy</p>
  </div>
</section>

<!-- Terms Content Section -->
<section class="terms-content-section">
  <div class="terms-container">
    <h2 class="terms-main-title">Privacy Policy</h2>
    
    <p class="terms-intro">
      Welcome to Safroo. By accessing or using our app and services, you agree to be bound by these 
      Terms and Conditions. Please read them carefully before using Safroo.
    </p>

    <div class="terms-item">
      <h3 class="terms-heading">1. Acceptance of Terms</h3>
      <p class="terms-text">
        By downloading, installing, or using the Safroo app, you agree to comply with and be legally bound by these Terms and Conditions. If 
        you do not agree, you may not use the service.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">2. Service Overview</h3>
      <p class="terms-text">
        Safroo connects users with drivers who provide transportation and guidance services around selected cities. Safroo does not own 
        vehicles nor directly employ drivers; instead, it facilitates connections between users and third-party service providers.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">3. User Responsibilities</h3>
      <p class="terms-text">
        Users must provide accurate personal information when registering. - Users must comply with all local laws and regulations during 
        tours. - Users are responsible for their own belongings during trips.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">4. Driver Responsibilities</h3>
      <p class="terms-text">
        Drivers must hold valid licenses and comply with all legal requirements. - Drivers must provide safe, respectful, and professional 
        service. - Drivers are not official tour guides but are expected to share knowledge of the city.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">5. Payments and Commission</h3>
      <p class="terms-text">
        Safroo charges a 15% commission fee on each booking. - Payments are processed securely through the app. - Users agree to pay all 
        applicable fees at the time of booking.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">6. Cancellations and Refunds</h3>
      <p class="terms-text">
        Users may cancel bookings in accordance with Safroo's cancellation policy stated in the app. - Refund eligibility depends on 
        cancellation timing and policy.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">7. Liability Disclaimer</h3>
      <p class="terms-text">
        Safroo acts solely as a booking platform and is not responsible for accidents, delays, or issues caused by drivers. - Safroo disclaims 
        liability for personal injuries, damages, or losses incurred during the trip.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">8. Privacy Policy</h3>
      <p class="terms-text">
        User data is collected and processed according to Safroo's Privacy Policy, which forms part of these Terms.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">9. Amendments</h3>
      <p class="terms-text">
        Safroo reserves the right to modify these Terms and Conditions at any time. Continued use of the app constitutes acceptance of any 
        updates.
      </p>
    </div>

    <div class="terms-item">
      <h3 class="terms-heading">10. Governing Law</h3>
      <p class="terms-text">
        These Terms and Conditions are governed by the laws of the United Arab Emirates. Disputes will be subject to the jurisdiction of UAE 
        courts.
      </p>
    </div>
  </div>
</section>
